import { React, Link, TextInput2 as TextInput, DropDown2 as DropDown } from "../../../../common";

const RenderChildOtherAssets = (props) => {
  const { path, item, count, otherAssetsTypes, onInputChanged } = props;

  const OnDeleteClicked = (e) => {
    e.preventDefault();
    if (onInputChanged) onInputChanged(`${path}.delete`.replace(/\./g, '_'), true);
  }

  return (
    <>
      {count > 1 && (
        <div className="formPartition">
          <div className="closePartition">
            <Link to="#" onClick={(e) => OnDeleteClicked(e)}>&#x2715; &nbsp;Delete</Link>
          </div>
        </div>
      )}
      <ul className="formContentIIcol">
        <li className="formContentIIcol">
          <div className="form1003ContentHead">Asset Type</div>
          <div className="typeicon"></div>
          <DropDown
            path={`${path}.assetType`}
            value={item?.assetType}
            items={otherAssetsTypes}
            displayName={"text"}
            displayValue={"value"}
            onInputChildChanged={onInputChanged}
          />
        </li>
        <li className="formContentIIcol">
          <div className="form1003ContentHead">Value</div>
          <div className="form_dollaricon"></div>
          <TextInput
            path={`${path}.cashOrMarketValue`}
            value={item?.cashOrMarketValue}
            valuetype={"FINANCE"}
            onInputChildChanged={onInputChanged}
          />
        </li>
      </ul>
    </>
  );
};

const Component = (props) => {
  const { items, otherAssetsTypes, onAddArrayList, onInputChanged } = props;
  const item = items && items.childs && items.childs.length > 0 ? items.childs[0] : null;

  // const { path, item, count, otherAssetsTypes, onInputChanged } = props;

  const OnAddNewAsset = (e) => {
    e.preventDefault();
    let obj = {
      title: item?.title,
      borrowerType: item?.borrowerType,
      delete: false
    };
    if (onAddArrayList) onAddArrayList('otherAssets', obj);
  };

  return (
    <>
      <div className="form1003BlkHead">
        <div className="formHeadContent">Other Assets You Have</div>
        <div className="form1003Blk_right">
          <input
            type="button"
            defaultValue="&#65291; Another"
            className="headRight_button"
            onClick={(e) => OnAddNewAsset(e)}
          />
        </div>
      </div>
      <div className="form1003ContentBlk">
        {items && items.childs && items.childs.map((x) => {
          if (!x.delete) {
            return (
              <RenderChildOtherAssets
                count={items.childs.filter((x) => !x.delete).length}
                key={x.index}
                path={`otherAssets.${x.index}`}
                item={x}
                otherAssetsTypes={otherAssetsTypes}
                onInputChanged={onInputChanged}
              />
            )
          } else { return null }
        })}
      </div>
    </>
  );
};

export default Component;
